// --------------------------------------------------
// Cached DOM
// --------------------------------------------------

const el = {
  searchInput: document.querySelector('.header-search__input-field'),
  searchBtn: document.querySelector('.header-main__search-btn'),
  searchForm: document.querySelector('.header-search__form'),
  menuHamburger: document.querySelector('.menu-hamburger'),
  megaMenuTriggers: document.querySelectorAll('.mega-menu-hamburger, .mega-menu__back-button, .country-switcher-btn'),
};

// --------------------------------------------------
// State helpers
// --------------------------------------------------
const setState = {
  search: (open) => document.body.classList.toggle('is-open-search', open),
  menu: (open) => document.body.classList.toggle('is-open-menu', open),
  scrolled: (value) => document.body.classList.toggle('is-scrolled', value),
  scrollUp: (value) => document.body.classList.toggle('is-scrolled-up', value),
};

// --------------------------------------------------
// Menu toggle
// --------------------------------------------------
el.menuHamburger?.addEventListener('click', (e) => {
  e.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  setState.search(false);
  setState.menu(!isOpen);
});

// --------------------------------------------------
// Mega menu clicks close search
// --------------------------------------------------
el.megaMenuTriggers.forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    setState.search(false);
  });
});

// --------------------------------------------------
// Search toggle
// --------------------------------------------------
el.searchBtn?.addEventListener('click', (e) => {
  e.preventDefault();

  const open = !document.body.classList.contains('is-open-search');
  setState.menu(false);
  setState.search(open);

  if (open) el.searchInput?.focus();
});

attachEvent('[data-close-search]', 'click', (e) => {
  e.preventDefault();
  setState.search(false);
  el.searchInput?.blur();
});

// --------------------------------------------------
// Close search (outside click)
// --------------------------------------------------
document.addEventListener('click', (e) => {
  if (!document.body.classList.contains('is-open-search')) return;

  if (el.searchForm?.contains(e.target) || el.searchBtn?.contains(e.target)) return;

  setState.search(false);
  el.searchInput?.blur();
});

// --------------------------------------------------
// Escape closes search
// --------------------------------------------------
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  setState.search(false);
  el.searchInput?.blur();
});

// --------------------------------------------------
// Scroll handling
// --------------------------------------------------
let lastY = window.scrollY;
let ticking = false;

function onScroll() {
  const y = window.scrollY;

  setState.scrolled(y > 100);
  setState.scrollUp(y < lastY);

  lastY = Math.max(y, 0);
  ticking = false;
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    requestAnimationFrame(onScroll);
    ticking = true;
  }
});

onScroll();
